import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { Question } from 'src/app/shared/sl-data/settings/settings-types';

@Component({
  selector: 'app-create-question-modal',
  templateUrl: './create-question-modal.component.html',
  styleUrls: ['./create-question-modal.component.scss']
})
export class CreateQuestionModalComponent {
  editForm: FormGroup;
  originalQuestion: Question;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateQuestionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const question: Question = data.question;
    this.originalQuestion = question;
    const type = question?.type === 'text' && question.auto === 'date' ? 'datetime' : (question?.type || 'text');
    this.editForm = this.fb.group({
      type: [type, Validators.required],
      question: [question.question || '', Validators.required],
      required: [!!question.required, Validators.required],
      acceptComment: [question.acceptComment || false],
    });
  }

  async onEditFormSubmit(formValue: any) {
    if (!this.editForm.valid) {
        return;
    }
    let result: Question = this.originalQuestion;
    switch(formValue.type){
      case 'datetime': 
        result = {
          type: 'text',
          order: this.originalQuestion.order,
          question: formValue.question,
          auto: 'date',
          required: formValue.required
        };
        break;
      case 'text':
        result = {
          type: 'text',
          order: this.originalQuestion.order,
          question: formValue.question,
          required: formValue.required,
        };
        break;
      case 'boolean':
        result = {
          type: 'boolean',
          order: this.originalQuestion.order,
          question: formValue.question,
          acceptButton: 'Yes',
          rejectButton: 'No',
          acceptComment: formValue.acceptComment
        };
        break;
    }
    this.dialogRef.close(result);
  }

  close() {
    this.dialogRef.close();
  }
} 